import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, waLink } from "../lib/constants";
import { useSite } from "../context/SiteContext";

const CITIES = ["Arapiraca", "Garanhuns", "Maceió", "Outra cidade"];
const USA = ["Nunca usei", "Já utilizei", "Uso atualmente"];
const PROCURA = ["Primeira prótese", "Trocar minha prótese", "Manutenção", "Mais informações"];

function detectOrigem() {
  const ref = (document.referrer || "").toLowerCase();
  if (ref.includes("instagram")) return "Instagram";
  if (ref.includes("google")) return "Google";
  if (ref.includes("facebook") || ref.includes("fb.")) return "Facebook";
  return "Site";
}

function cityKey(cidade) {
  const c = (cidade || "").toLowerCase();
  if (c.includes("garanhuns")) return "garanhuns";
  if (c.includes("maceió") || c.includes("maceio")) return "maceio";
  if (c.includes("arapiraca")) return "arapiraca";
  return "arapiraca";
}

const inputCls =
  "w-full bg-[#0e0e0e] border border-white/15 rounded-sm px-4 py-3 text-white placeholder-zinc-500 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors";

export default function LeadForm({ paginaOrigem = "Prótese", defaultCidade = "" }) {
  const { site } = useSite();
  const [form, setForm] = useState({
    nome: "",
    telefone: "",
    cidade: defaultCidade,
    idade: "",
    usa_protese: "",
    procura: "",
  });
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nome || !form.telefone) {
      toast.error("Preencha nome e WhatsApp.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/leads", {
        ...form,
        servico_interesse: form.procura,
        unidade: form.cidade,
        origem: detectOrigem(),
        pagina_origem: paginaOrigem,
      });
      toast.success("Avaliação solicitada! Vamos te levar ao WhatsApp.");
      const key = cityKey(form.cidade);
      const msg = `${site?.whatsapp_messages?.[key] || ""} Meu nome é ${form.nome}.`;
      window.open(waLink(site, key, msg), "_blank");
      setForm({ nome: "", telefone: "", cidade: defaultCidade, idade: "", usa_protese: "", procura: "" });
    } catch (err) {
      toast.error("Não foi possível enviar. Tente pelo WhatsApp.");
    } finally {
      setLoading(false);
    }
  };

  const isMaceio = (form.cidade || "").toLowerCase().includes("mace");

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="lead-form">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input className={inputCls} placeholder="Nome" value={form.nome} onChange={(e) => set("nome", e.target.value)} data-testid="lead-nome" />
        <input className={inputCls} placeholder="WhatsApp" value={form.telefone} onChange={(e) => set("telefone", e.target.value)} data-testid="lead-telefone" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <select className={inputCls} value={form.cidade} onChange={(e) => set("cidade", e.target.value)} data-testid="lead-cidade">
          <option value="">Cidade</option>
          {CITIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <input className={inputCls} placeholder="Idade" value={form.idade} onChange={(e) => set("idade", e.target.value)} data-testid="lead-idade" />
      </div>

      {isMaceio && (
        <div className="border border-gold/40 bg-gold/5 rounded-sm px-4 py-3 text-sm text-gold" data-testid="lead-maceio-note">
          Atendimento realizado em parceria com a Arena Barbearia.
        </div>
      )}

      <div>
        <label className="overline-label text-[11px] text-zinc-400 block mb-2">Você já usa prótese capilar?</label>
        <select className={inputCls} value={form.usa_protese} onChange={(e) => set("usa_protese", e.target.value)} data-testid="lead-usa-protese">
          <option value="">Selecione</option>
          {USA.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      <div>
        <label className="overline-label text-[11px] text-zinc-400 block mb-2">O que você procura?</label>
        <select className={inputCls} value={form.procura} onChange={(e) => set("procura", e.target.value)} data-testid="lead-procura">
          <option value="">Selecione</option>
          {PROCURA.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      <button
        type="submit"
        disabled={loading}
        data-testid="lead-submit"
        className="w-full inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-hover text-black font-heading font-600 tracking-wide px-6 py-4 rounded-sm transition-colors disabled:opacity-60"
      >
        {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : null}
        QUERO MINHA AVALIAÇÃO
      </button>
      <p className="text-xs text-zinc-500 text-center">Ao enviar, você concorda em ser contatado pela nossa equipe pelo WhatsApp.</p>
    </form>
  );
}
